"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateProductSalable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _CreateProductSalableForm = require("./CreateProductSalableForm");
var _index = require("../../config/index");
var _reactUse = require("react-use");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CategoryOfProductNotFinal = null;
var CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT;
var SORT_CATEGORIES_BY;
try {
  CategoryOfProductNotFinal = require("react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField").default;
  CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT = require("react-platform-category-of-product/dist/config").CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT;
  SORT_CATEGORIES_BY = require("react-platform-category-of-product/dist/config").SORT_CATEGORIES_BY;
} catch (e) {}
var SpecificitiesOfProductFields = null;
try {
  SpecificitiesOfProductFields = require("react-platform-specificity-of-product/dist/SpecificityOfProductWithSections/SpecificitiesOfProductFields").SpecificitiesOfProductFields;
} catch (error) {}
var hasReservationOption = false;
try {
  hasReservationOption = Boolean(require('react-platform-reservation/dist/Reservation/index').default);
} catch (error) {}
var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    areaContainer: _defineProperty({
      paddingBottom: '6rem',
      paddingTop: '18rem',
      paddingRight: '12rem',
      paddingLeft: '12rem'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: 4,
      paddingRight: 4,
      paddingTop: '8rem'
    }),
    textContainer: {
      textAlign: 'center'
    }
  };
});
var CreateProductSalable = (0, _Translations.injectIntl)(function (props) {
  var _product$category3;
  var params = (0, _reactRouterDom.useParams)();
  var isUpdate = params.id;
  (0, _reactUse.useTitle)(isUpdate ? props.intl.formatMessage({
    id: "Product modification title",
    defaultMessage: "Product modification title"
  }) : props.intl.formatMessage({
    id: "Product creation title",
    defaultMessage: "Product creation title"
  }));
  var theme = (0, _core.useTheme)();
  var classes = useStyle();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      var _state$categoryOfProd, _state$specificityOfP;
      return _objectSpread({
        product: state.ProductReducer.product,
        categories: (_state$categoryOfProd = state.categoryOfProductReducer) === null || _state$categoryOfProd === void 0 ? void 0 : _state$categoryOfProd.categories,
        specificities: (_state$specificityOfP = state.specificityOfProductReducer) === null || _state$specificityOfP === void 0 ? void 0 : _state$specificityOfP.specificities,
        isProductFetchingInProgress: state.ProductReducer.isProductFetchingInProgress
      }, hasReservationOption && {
        reservationOption: state.reservationReducer.reservation_option
      });
    }),
    product = _useSelector.product,
    categories = _useSelector.categories,
    specificities = _useSelector.specificities,
    isProductFetchingInProgress = _useSelector.isProductFetchingInProgress,
    reservationOption = _useSelector.reservationOption;
  (0, _react.useEffect)(function () {
    var _product$category;
    var _props$useDefaultFetc = props.useDefaultFetchCategories,
      useDefaultFetchCategories = _props$useDefaultFetc === void 0 ? true : _props$useDefaultFetc;
    if (isUpdate) {
      dispatch({
        type: "FETCH_PRODUCT",
        endpoint: props.endpoint || "salable-products",
        id: params.id
      });
    }
    // we fetch the main categories only on the creation or in update but product does't have category
    if (useDefaultFetchCategories && CategoryOfProductNotFinal && (!isUpdate || isUpdate && !Boolean((_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.id))) {
      dispatch({
        type: "FETCH_CATEGORIES_OF_PRODUCT",
        params: {
          parent_category_id: 'null',
          _sort: SORT_CATEGORIES_BY,
          _fields: CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT
        }
      });
    }
    if (SpecificitiesOfProductFields && _lodash.default.isEmpty(specificities)) {
      dispatch({
        type: "FETCH_SPECIFICITIES_OF_PRODUCT",
        params: {
          _embed: "section"
        }
      });
    }
    if (_index.USE_SELLER_COMMISSION) {
      dispatch({
        type: "FETCH_COMMISSION_OF_SELLER"
      });
    }
    if (hasReservationOption && _lodash.default.isEmpty(reservationOption)) {
      dispatch({
        type: "FETCH_RESERVATION_OPTION"
      });
    }
    if (_index.USE_ADDRESS_OF_STORE_IN_PRODUCT_CREATION) {
      dispatch({
        type: "FETCH_STORE"
      });
    }
    return function () {
      dispatch({
        type: "INITIALIZE_PRODUCT"
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _product$category2;
    var _props$useDefaultFetc2 = props.useDefaultFetchCategories,
      useDefaultFetchCategories = _props$useDefaultFetc2 === void 0 ? true : _props$useDefaultFetc2;
    if (useDefaultFetchCategories && CategoryOfProductNotFinal && isUpdate && (_product$category2 = product.category) !== null && _product$category2 !== void 0 && _product$category2.id) {
      // fetch selected category of product + all main categories
      dispatch({
        type: "FETCH_CATEGORIES_OF_PRODUCT",
        params: {
          _fields: CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT,
          id: product.category.id,
          _sort: SORT_CATEGORIES_BY
        },
        onSuccess: function onSuccess() {
          // we use FETCH_ADDITIONAL_CATEGORIES_OF_PRODUCT because we need to push the given categories to the old data.
          // and use differente state of progressing
          dispatch({
            type: "FETCH_ADDITIONAL_CATEGORIES_OF_PRODUCT",
            params: {
              parent_category_id: 'null',
              _sort: SORT_CATEGORIES_BY,
              _fields: CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT
            }
          });
        }
      });
    }
  }, [(_product$category3 = product.category) === null || _product$category3 === void 0 ? void 0 : _product$category3.id]);
  if (isUpdate && isProductFetchingInProgress) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      className: classes.areaContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
      type: 'bars',
      color: theme.palette.primary.main,
      height: 60,
      width: 60
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.textContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Chargement en cours",
      defaultMessage: "Chargement en cours"
    }))));
  }
  if (isUpdate && _lodash.default.isEmpty(product)) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      className: classes.areaContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.textContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "We can't find this product, please try again",
      defaultMessage: "We can't find this product, please try again"
    }))));
  }
  var CreateProductSalableForm = props.createProductSalableForm || _CreateProductSalableForm.CreateProductSalableForm;
  return /*#__PURE__*/_react.default.createElement(CreateProductSalableForm, props);
});
exports.CreateProductSalable = CreateProductSalable;